"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const store_1 = require("../store");
const fade = (0, react_1.keyframes) `
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;
const rotate = (0, react_1.keyframes) `
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
`;
const Button = styled_1.default.button(() => (0, react_1.css) `
    position: relative;

    display: inline-block;

    line-height: 1em;

    cursor: pointer;

    transition: all 0.33s ease-in-out;

    > span {
      transition: all 0.3s;
      transition-delay: 0.3s;
    }
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;

      display: inline-block;
      content: '';
    }
  `, ({ state }) => state !== 'WAITING' &&
    state !== 'CHANGED' &&
    (0, react_1.css) `
      cursor: default;

      pointer-events: none;

      > span {
        opacity: 0;

        transition-delay: 0s;
      }
    `, ({ state }) => state === 'PENDING' &&
    (0, react_1.css) `
      &:after {
        width: 0.5em;
        height: 0.5em;

        border: 3px solid rgba(255, 255, 255, 0.33);
        border-top-color: #fff;

        border-radius: 50%;
        transform: translate(-50%, -75%) rotate(-45deg);

        animation: ${fade} 0.33s ease, ${rotate} 0.66s linear 0s infinite;
      }
    `, ({ state }) => state === 'ERROR' &&
    (0, react_1.css) `
      &:after {
        width: 1em;
        height: 1em;

        background: linear-gradient(
            to bottom,
            transparent 44%,
            #fff 44%,
            #fff 56%,
            transparent 56%
          ),
          linear-gradient(
            to right,
            transparent 44%,
            #fff 44%,
            #fff 56%,
            transparent 56%
          );

        transform: translate(-50%, -50%) rotate(-45deg);

        animation: ${fade} 0.6s ease;
      }
    `, ({ state }) => state === 'SUCCESS' &&
    (0, react_1.css) `
      &:after {
        width: 1em;
        height: 0.5em;

        border: 3px solid #fff;
        border-top-width: 0;
        border-right-width: 0;

        transform: translate(-50%, -75%) rotate(-45deg);

        animation: ${fade} 0.6s ease;
      }
    `);
function SubmitButton(_a) {
    var { children, as, stateCSS = {
        CHANGED: {},
        ERROR: { backgroundColor: '#dd335c' },
        PENDING: {},
        SUCCESS: {},
        WAITING: {},
    } } = _a, extraProps = __rest(_a, ["children", "as", "stateCSS"]);
    const formStatus = (0, store_1.useAppSelector)(state => state.status);
    const disabled = formStatus === 'PENDING' ? true : false;
    return (react_2.default.createElement(Button, Object.assign({ type: "submit", state: formStatus, disabled: disabled, style: stateCSS[formStatus], as: as }, extraProps),
        react_2.default.createElement("span", null, children)));
}
exports.default = SubmitButton;
